module.exports = __webpack_public_path__ + "assets/cover-bottom-default-80fa75c8.png";